<h1 mat-dialog-title>
  {{ modelRecived ? 'Editar Rangos' : 'Agregar Rangos' }}
</h1>

<form [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P195F0001">
  <div mat-dialog-content>
    <mat-grid-list [cols]="breakpoint" rowHeight="90px" (window:resize)="onResize($event)">
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Perfil</mat-label>
            <input matInput placeholder="123" formControlName="clavePerfil" type="text" [readonly]="modelRecived" appPermissionControl="P195K0001" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>No. Variable</mat-label>
            <input matInput placeholder="Ejemplo..." formControlName="variable" type="text" [readonly]="modelRecived" appPermissionControl="P195K0002" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Valor</mat-label>
            <mat-select formControlName="valorStr" appPermissionControl="P195K0003">
              <mat-option value="capturado"> Capturado </mat-option>
              <mat-option value="noCapturado"> No Capturado </mat-option>
              <mat-option value="no"> No </mat-option>
              <mat-option value="si"> Si </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Rangos</mat-label>
            <input matInput placeholder="123" formControlName="rango1" type="number" appPermissionControl="P195K0004" />
          </mat-form-field>
        </ng-container>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <input matInput placeholder="123" formControlName="rango2" type="number" appPermissionControl="P195K0005" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Política</mat-label>
            <mat-select formControlName="politica" appPermissionControl="P195K0006">
              <mat-option value="No"> No </mat-option>
              <mat-option value="Si"> Si </mat-option>
              <mat-option value="SN"> SN </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Siguiente</mat-label>
            <input matInput placeholder="Ejemplo..." formControlName="siguiente" type="text" appPermissionControl="P195K0007" />
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>

      <mat-grid-tile *ngIf="model">
        <ng-container>
          <button mat-raised-button type="button" color="accent" (click)="openProductos()" style="margin-right: 10px" appPermissionControl="P195B0001">
            <mat-icon>align_horizontal_right</mat-icon> Productos
          </button>

          <button mat-raised-button type="button" color="accent" (click)="openActividades()" appPermissionControl="P195B0002"><mat-icon>flag-variant</mat-icon> Actividades</button>
        </ng-container>
      </mat-grid-tile>
    </mat-grid-list>
  </div>

  <div mat-dialog-actions>
    <ng-container *ngIf="!loading"
      ><button class="botonFm btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P195B0003">Cancelar</button>
      <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P195B0004">
        {{ modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
    </ng-container>
    <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P195B0005">
      Cargando
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </button>
  </div>
</form>
